export default __webpack_public_path__ + "static/careers-iste-awards-c197f6aaf329e2d3babf88c681f87e19.png";